import React                          	from 'react';
import { RouterProvider, router }     	from 'app/router';
import AuthorizationContext     		from 'auth/keycloak-instance';
import { 
	useDispatch
}                                  		from 'react-redux';
import Lottie 							from 'react-lottie';
import loadingAnimationData 			from 'app/common/constants/loading.json';
import ChatbotWidget 					from 'app/common/chatbot/widget';

const App = _props => {
	const dispatch 			= useDispatch();
	const [ s, setState ] 	= React.useState({
		isLoading 				: false,
		isAuthenticated			: false,
		isError					: false
	})

	React.useEffect(() => {
		if (AuthorizationContext.isAvailable()) {
			setState(prevState => ({ ...prevState, isLoading: true }));
			AuthorizationContext.init({ dispatch }).then( response => {
				if (response) {
					setState(prevState => ({ ...prevState, isAuthenticated: true, isLoading: false }));					
				}
			}).catch( err => {
				AuthorizationContext.login();
				setState(({ isError: true, isAuthenticated: false, isLoading: false }));		
			})
		} else {
			setState(prevState => ({ ...prevState, isLoading: false }));
		}
	}, [ dispatch ])

	const renderContent = () => {
		return !AuthorizationContext.isInitialized || s.isLoading
				?	<div id="application-loader">
						<div className="spinner-container">
							<Lottie 
								options	= {{ 
									loop			: true,
									autoplay		: true,
									animationData	: loadingAnimationData,
									rendererSettings: {
									preserveAspectRatio	: "xMidYMid slice"
									}
								}}
								height	= { 80 }
								width	= { 80 }
							/>		
						</div>
					</div>
				:	<>
						<RouterProvider router={ router } />
						<ChatbotWidget />
					</>
	}

	return renderContent()
}

export default App